var AdaptiveImage = require("../../../../web/node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/loading-spinner-white-transparent.bd43aab4.png","uri@3x": __webpack_public_path__ + "static/media/loading-spinner-white-transparent.e7a7f354.png","uri@2x": __webpack_public_path__ + "static/media/loading-spinner-white-transparent.4817c1fe.png",
    width: 24,
    height: 24
});